import React, { lazy } from "react";
import { Route, Routes, Outlet, Navigate } from "react-router-dom";
import useAuth from "src/auth/useAuth";
import DashboardLayout from "src/layout";

const DashbordPage = lazy(() => import("../pages/dashboard"));
const LoginPage = lazy(() => import("../pages/login"));
const CreatePlatePage = lazy(() => import("../pages/create-plate"));
const PlateDetailsPage = lazy(() => import("../pages/plate-details"));
const AuditPage = lazy(() => import("../pages/audit"));
const ManageTablesPage = lazy(() => import("../pages/manage-tables"));
const AllPlatesPage = lazy(() => import("../pages/all-plates"));
const CreateSeedBagPage = lazy(() => import("../pages/create-seedBag"));
const AllSeedBagsPage = lazy(() => import("../pages/all-seed-bags"));
const SeedBagDetailsPage = lazy(() => import("../pages/seedBag-details"));

const Router: React.FC = () => {
  const isLocalEnvironment = process.env.NODE_ENV === "development";
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={isLocalEnvironment ? <Navigate to="/" /> : <LoginPage />}
      />
      <Route
        element={
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        }
      >
        <Route path="/" element={<DashbordPage />} />
        <Route path="/create" element={<CreatePlatePage />} />
        <Route path="/plates/:plateId" element={<PlateDetailsPage />} />
        <Route path="/plates/:plateId/audit" element={<AuditPage />} />
        <Route path="/manage-tables" element={<ManageTablesPage />} />
        <Route path="/all-plates" element={<AllPlatesPage />} />
        <Route path="/create-seed-bag" element={<CreateSeedBagPage />} />
        <Route path="/all-seed-bags" element={<AllSeedBagsPage />} />
        <Route path="/seedbags/:seedBagId" element={<SeedBagDetailsPage />} />
        {user?.roles.includes("admin") && (
          <Route path="/metadata" element={<ManageTablesPage />} />
        )}
      </Route>
    </Routes>
  );
};

export default Router;
